import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#07050A] py-12 px-4 border-t border-white/5" data-id="element-129">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center gap-5" data-id="element-130">
        <p className="text-white text-sm md:text-base font-bold" data-id="element-131">
          MegaPack Cursada Sin Estrés — Recursos para estudiantes universitarios
        </p>

        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-132">
          <a href="https://instagram.com/infinitamente.digital" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gradPurple hover:text-gradPink transition-colors duration-300 text-sm font-bold" data-id="element-133">
            <InstagramIcon className="w-5 h-5" data-id="element-134" />
            @infinitamente.digital
          </a>
          <a href="mailto:soporte@infinita-mente.online" className="flex items-center gap-2 text-textMuted hover:text-white transition-colors duration-300 text-sm font-bold" data-id="element-135">
            <MailIcon className="w-5 h-5" data-id="element-136" />
            soporte@infinita-mente.online
          </a>
        </div>

        <p className="text-white/30 text-xs font-medium mt-4" data-id="element-137">
          © 2026 InfinitaMenteDigital. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}